document.addEventListener("DOMContentLoaded", function () {

  const wishlistCountElem = document.querySelector(".wishlist-count");
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  function updateWishlistCount() {
    const count = wishlist.length;
    if (!wishlistCountElem) return;

    const visibleSpan = wishlistCountElem.querySelector("span[aria-hidden='true']");
    const hiddenSpan = wishlistCountElem.querySelector(".visually-hidden");

    if (visibleSpan) visibleSpan.textContent = count;
    if (hiddenSpan) hiddenSpan.textContent = `${count} item${count !== 1 ? 's' : ''}`;

    // 🔥 ADD THIS PART
    if (count === 0) {
      wishlistCountElem.style.display = "none";
    } else {
      wishlistCountElem.style.display = "flex";
    }
  }

  function saveWishlist() {
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    updateWishlistCount();
  }

  function isInWishlist(handle) {
    return wishlist.some(item => item.handle === handle);
  }

  updateWishlistCount();

  // 🔥 EVENT DELEGATION (works everywhere)
  document.addEventListener("click", function (e) {

    const btn = e.target.closest(".wishlist-icon");
    if (!btn) return;

    const handle = btn.dataset.productHandle || btn.closest("[data-product-handle]")?.dataset.productHandle;

    if (!handle) {
      console.error("Handle missing");
      return;
    }

    // 🔒 Prevent double click
    if (btn.classList.contains("loading")) return;
    btn.classList.add("loading");

    // Already in wishlist → redirect
    if (isInWishlist(handle)) {
      btn.classList.remove("loading");
      return;
    }

    // Add to wishlist
    fetch(`/products/${handle}.js`)
      .then(res => {
        if (!res.ok) throw new Error("Fetch failed");
        return res.json();
      })
      .then(product => {

        // 🔥 Final duplicate check
        if (!isInWishlist(handle)) {
          wishlist.push({
            title: product.title,
            handle: product.handle,
            price: product.price,
            image: product.images[0],
            url: product.url
          });

          saveWishlist();
        }

        btn.classList.add("active");
      })
      .catch(console.error)
      .finally(() => {
        btn.classList.remove("loading");
      });

  });

  // ✅ Remove item from wishlist page
  document.addEventListener("click", function (e) {
    if (e.target.matches(".wishlist-remove-btn")) {

      const handle = e.target.dataset.handle;

      wishlist = wishlist.filter(item => item.handle !== handle);
      saveWishlist();

      const itemEl = e.target.closest(".wish-item");
      if (itemEl) itemEl.remove();
    }
  });

  // ✅ Wishlist count click → redirect
  if (wishlistCountElem) {
    wishlistCountElem.addEventListener("click", function (e) {
      e.stopPropagation();
      window.location.href = "/pages/wishlist";
    });
  }

  // 🔥 Auto सक्रिय class for dynamically loaded icons
  const observer = new MutationObserver(() => {
    document.querySelectorAll(".wishlist-icon").forEach(btn => {
      const handle = btn.dataset.productHandle || btn.closest("[data-product-handle]")?.dataset.productHandle;

      if (handle && isInWishlist(handle)) {
        btn.classList.add("active");
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

});